import { DBFactory } from "~/classes/database/db_factory";
import { WordsToIgnore } from "./wordsToIgnore.model";

export class WordsToIgnoreService {
  static async getSystemWordsToIgnore() {
    const db = DBFactory.createDatabase();

    const documentData = await db.get({
      collection: "wordsToIgnore",
      path: "/wordsToIgnore/default",
    });

    return WordsToIgnore.fromMap(documentData);
  }

  static async getUserWordsToIgnore(userId: string) {
    const db = DBFactory.createDatabase();

    try {
      const documentData = await db.get({
        collection: "wordsToIgnore",
        path: `/wordsToIgnore/${userId}`,
      });

      if (documentData) {
        return WordsToIgnore.fromMap(documentData);
      }
    } catch (error) {}

    return new WordsToIgnore({
      id: userId,
      words: [],
    });
  }

  static async getAllWordsToIgnore(userId: string): Promise<string[]> {
    let systemWords = [] as string[];
    let userWords = [] as string[];
    try {
      const getSystemWordsToIgnore = await this.getSystemWordsToIgnore();
      systemWords = getSystemWordsToIgnore.words;
    } catch (error) {}

    try {
      const getUserWordsToIgnore = await this.getUserWordsToIgnore(userId);
      userWords = getUserWordsToIgnore.words;
    } catch (error) {}

    return [...systemWords, ...userWords];
  }
}
